import useUserOnlineStatusText from 'APP/main/hooks/userOnlineStatusText';

import { IPopupUserItemLocalStore, IPopupUserItemPresenter } from './PopupUserItem.types';

export const usePopupUserItemPresenter = (
  data: IPopupUserItemPresenter
): IPopupUserItemLocalStore => {
  const userOnlineStatusText: string = useUserOnlineStatusText(data);

  return {
    userOnlineStatusText,
  } as IPopupUserItemLocalStore;
};
